import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EverythingYourPetNeedsHero from "./sections/EverythingYourPetNeedsHero";
import SweetDelightsCollection from "./sections/SweetDelightsCollection";
import MainFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EverythingYourPetNeedsHero />
      <SweetDelightsCollection />
      <MainFooter />
    </div>;
}